import { Modal, Button, List, Divider } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ContentModalProps } from "../../constants/Constants";
import { selectedNotification } from "../../pages/Notifications/actions/notificationsService";

export default function ContentModal({
  errors,
  contentModalType,
  showModal
}) {
  const [modalProps, setModalProps] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    if (contentModalType === "error") {
      setModalProps((values) => {
        return { values, ...ContentModalProps[contentModalType] };
      });
    }
  }, []);

  const handleClose = (e) => {
    if(!(e.target.tagName == "BUTTON" || e.target.tagName == "SPAN")) return;
    dispatch(
      selectedNotification({
        showModal: false,
        notificationErrorList: [],
      })
    );
  };

  return (
    <>
      <Modal
        open={showModal}
        onCancel={handleClose}
        className={modalProps?.modalClass}
        width={modalProps?.modalWidth}
        footer={[
          <Button
            key="close"
            type="button"
            className="btn muted-button deca-btn-orange"
            onClick={handleClose}
          >
            Close
          </Button>,
        ]}
      >
        <div className="modal-content">
          <div>{modalProps?.modalTitle}</div>
          <Divider />
          <List
            className={modalProps?.listClassName}
            dataSource={errors}
            renderItem={(error) => <List.Item>{error}</List.Item>}
            style={{ maxHeight: "300px", overflowY: "auto" }}
          />
        </div>
      </Modal>
    </>
  );
}
